module.exports = __webpack_public_path__ + "static/media/gift.b69cc95e.svg";